mod.modules.define("WatchlistCounter", "BaseModule", function (fn) {
	fn.prototype.init = function (params) {
		this.base("init", params);
		this.Symbol = params.Symbol;
	};

	fn.prototype.observables = {
		"watchlist - update": function () {
			this.reload({Symbol: this.Symbol});
		}
	};
});

